import { live, LiveController } from "@camertron/live-component";

type KeyboardProps = {
  on_key: (key: string) => void
}

@live("Wordle::Keyboard")
export class Keyboard extends LiveController<KeyboardProps> {
  static targets = ["keys"];

  on_key(event: Event) {
    const key = (event.target as HTMLElement).closest(".key").getAttribute("data-key");
    this.props.on_key(key);
  }
}
